<!-- Cabeçalho -->
<div class="panel-heading panel-heading-list">

  <!-- Lado esquerdo -->
  <div class="pull-left">

    <!-- Título -->
    <span class="pointer" ng-click="card.activateActivity(activity)">
      <b ng-if="card.isTratamentoSemente(activity)">Tratamento de Sementes</b>
      <span ng-if="!card.isTratamentoSemente(activity)">
        <b>{{activity.gleba.descricao}}</b> ({{activity.gleba.area_total | number:0}}ha)
      </span>
    </span>
    <br>
    <!-- Fim: Título -->

    <!-- Duração da visita (se houver) -->
    <small ng-show="activity.tempo_visita.descricao">
      <b>Duração da visita:</b> {{activity.tempo_visita.descricao}}
    </small>
    <br ng-show="activity.tempo_visita.descricao">
    <!-- Fim: Duração da visita -->

    <!-- Ícones de notificação -->
    <span ng-repeat="notification in activity.notificacoes"
          class="text-white pointer activity-notification"
          ng-class="{'item-active': notification.active}"
          ng-click="card.activateNotification(notification, activity)">
      <i agro-icon-historico historico="{tipo : notification.tipo}"
         uib-tooltip="{{notification.tipo_humanize}}"
         tooltip-class="tooltip-lines-width"
         tooltip-append-to-body="true"
         tooltip-placement="top-left"></i>
      <span class="icon-selected" ng-if="notification.active">
        <i class="fa fa-chevron-up"></i>
      </span>
    </span>
    <!-- Fim: Ícones de notificação -->

  </div>
  <!-- Fim: Lado Esquerdo -->

  <!-- Ícones detalhes -->
  <div class="panel-header-icons pull-right">

    <!-- Ícone stand -->
    <span class="label alert-icon pointer margin-left"
          ng-class="card.iconClasses(activity.stand)"
          ng-if="activity.stand"
          ng-click="card.activateStandSummary(activity.stand, activity)">
      <i agro-icon-historico historico="{tipo: activity.stand.tipo}"
          uib-tooltip="{{activity.stand.hint}}"
          tooltip-append-to-body="true"
          tooltip-class="tooltip-lines-width"
          tooltip-placement="right"></i>
    </span>
    <!-- Fim: Ícone stand -->

    <!-- Ícone dropdown stands -->
    <span class="btn-group label bg-neutro alert-icon pointer margin-left"
          uib-dropdown dropdown-append-to-body="true"
          ng-if="activity.gerais.stand.length > 1"
          ng-class="{'item-active': card.hasItemActive(activity.gerais.stand)}">
      <i agro-icon-historico historico="{tipo: activity.gerais.stand[0].tipo}" uib-dropdown-toggle></i>
      <ul class="dropdown-menu no-margin" uib-dropdown-menu>
        <li ng-repeat="stand in activity.gerais.stand">
          <a class="pointer item-dropdown-geral" ng-click="card.activateStandSummary(stand, activity)">
            <span class="label alert-icon pointer margin-right"
                  ng-class="card.iconClasses(stand)">
              <i agro-icon-historico historico="{tipo: stand.tipo}"></i>
            </span>
            {{stand.hint}}
          </a>
        </li>
      </ul>
    </span>
    <!-- Fim: Ícone dropdown stands -->

    <!-- Ícone produtividade -->
    <span class="label alert-icon pointer margin-left"
          ng-class="card.iconClasses(activity.productivity)"
          ng-if="activity.productivity"
          ng-click="card.activateProductivitySummary(activity.productivity, activity)">
      <i agro-icon-historico historico="{tipo: activity.productivity.tipo}"
          uib-tooltip="{{activity.productivity.hint}}"
          tooltip-append-to-body="true"
          tooltip-class="tooltip-lines-width"
          tooltip-placement="right"></i>
    </span>
    <!-- Fim: Ícone produtividade -->

    <!-- Ícone dropdown produtividade -->
    <span class="btn-group label bg-neutro alert-icon pointer margin-left"
          uib-dropdown dropdown-append-to-body="true"
          ng-if="activity.gerais.produtividade.length > 1"
          ng-class="{'item-active': card.hasItemActive(activity.gerais.produtividade)}">
      <i agro-icon-historico historico="{tipo: activity.gerais.produtividade[0].tipo}" uib-dropdown-toggle></i>
      <ul class="dropdown-menu no-margin" uib-dropdown-menu>
        <li ng-repeat="productivity in activity.gerais.produtividade">
          <a class="pointer item-dropdown-geral" ng-click="card.activateProductivitySummary(productivity, activity)">
            <span class="label alert-icon pointer margin-right"
                  ng-class="card.iconClasses(productivity)">
              <i agro-icon-historico historico="{tipo: productivity.tipo}"></i>
            </span>
            {{productivity.hint}}
          </a>
        </li>
      </ul>
    </span>
    <!-- Fim: Ícone dropdown produtividade -->

  </div>
  <!-- Fim: Ícones detalhes -->

  <!-- Ícone de novos registros -->
  <i class="fa fa-bell-o new-histories" uib-tooltip="Registros novos" tooltip-placement="top-right" tooltip-append-to-body="true"></i>

</div>
<!-- Fim: Cabeçalho -->

<!-- Conteúdo/detalhes -->
<div class="panel-body" ng-show="activity.active && card.activityHasContent(activity)">
  <activity-resumo-afericoes tipo="card.cardDataType" data="card.data[card.cardDataType]" ng-if="card.cardDataType === 'semeadura_afericao' || card.cardDataType === 'colheita_afericao' || card.cardDataType === 'aplicacao_afericao'"></activity-resumo-afericoes>
  <activity-resumo-anotacoes tipo="card.cardDataType" data="card.data.anotacao" ng-if="card.data.anotacao.length && card.cardDataType === 'anotacao'"></activity-resumo-anotacoes>
  <activity-resumo-ocorrencias ng-class="card.ocorrenciaClassName(card.cardDataType)" tipo="card.cardDataType" data="card.data[card.cardDataType]" ng-if="card.hasOcorrencias()"></activity-resumo-ocorrencias>
</div>
<!-- Fim: Conteúdo/detalhes -->
